import { render, staticRenderFns } from "./BotonesAcuerdoDistribucion.vue?vue&type=template&id=7338da76&"
import script from "./BotonesAcuerdoDistribucion.vue?vue&type=script&lang=js&"
export * from "./BotonesAcuerdoDistribucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports